import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LightbulbDim from './icon-lightbulb-dim.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LightbulbDim {...validProps} />;
}
SvgComponent.iconName = 'lightbulb-dim';

export const LightbulbDimIcon = svgIconWrapper(SvgComponent);
